import { render, staticRenderFns } from "./stopTable.vue?vue&type=template&id=6317201c&scoped=true&"
import script from "./stopTable.vue?vue&type=script&lang=js&"
export * from "./stopTable.vue?vue&type=script&lang=js&"
import style0 from "./stopTable.vue?vue&type=style&index=0&id=6317201c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6317201c",
  null
  
)

export default component.exports